import React, { createContext, useContext, useState } from "react";

const TimezoneContext = createContext();

const getLocalTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
};
//At user login timezone is set as per local timezone .

export const TimezoneProvider = ({ children }) => {
  const [timezone, setTimezoneState] = useState(() => {
    const savedTimezone = localStorage.getItem("timezone");

    return savedTimezone || getLocalTimezone();
  });

  const updateTimezone = (tz) => {
    localStorage.setItem("timezone", tz);
    setTimezoneState(tz);
  };

  return (
    <TimezoneContext.Provider
      value={{
        timezone,
        setTimezone: updateTimezone,
      }}
    >
      {children}
    </TimezoneContext.Provider>
  );
};

export const useTimezone = () => {
  const context = useContext(TimezoneContext);

  if (!context) {
    throw new Error("useTimezone must be used inside TimezoneProvider");
  }

  return context;
};